import React from "react";
import "./toggle.css";
import { useDispatch, useSelector } from "react-redux";
import { selectSindromeAnalisis } from "../../../state/sindromeAnalisis/selectors";
import {
  agregarSindromeAnalisis,
  borrarSindromeAnalisis,
} from "../../../state/sindromeAnalisis/actions";

const Toggle = ({ codSindrome }) => {
  const SindromeAnalisisList = useSelector(selectSindromeAnalisis);
  const dispatch = useDispatch();
  const active = SindromeAnalisisList.includes(codSindrome);

  const handleToggle = () => {
    if (active) {
      dispatch(borrarSindromeAnalisis(codSindrome));
    } else {
      dispatch(agregarSindromeAnalisis(codSindrome));
    }
  };

  return (
    <div className="toggle-container" onClick={handleToggle}>
      <div className={`slider ${active ? "on" : "off"}`}>
        <div className="thumb" />
      </div>
    </div>
  );
};

export default Toggle;
